import styles from './Tier.less';

import React, { Component, PropTypes } from 'react';

import FormattedMessage from 'FormattedMessage/FormattedMessage';
import SearchResultList from 'SearchResultList/SearchResultList';

export default class Tier extends Component {

  static propTypes = {
    tierNumber: PropTypes.number.isRequired,
    header: PropTypes.object,
    jobs: PropTypes.array.isRequired
  };

  static defaultProps = {
    header: null
  };

  headerExists() {
    const { header } = this.props;

    return header !== null && header.parts;
  }

  render() {
    const { tierNumber, header, jobs } = this.props;

    return (
      <div>
        {
          this.headerExists() &&
            <h1
              className={header.isDivider ? styles.dividerHeader : styles.standardHeader}
              data-automation={`tier${tierNumber}header`}>
              <FormattedMessage message={header} />
            </h1>
        }
        <SearchResultList jobs={jobs} />
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/TieredSearchResultList/components/Tier/Tier.js
 **/